export const lista = [

    {
        id: 1,
        icon: 'fas fa-magnet',
        nombre: 'Herrería',
        descripcion: 'Elaboramos exhibidores para supermercados, expos, convenciones, terminaciones para muebles del hogar, portones basculantes, tinglados (chapas, ACM, acero inox, policarbonato).',
        descripcionLarga: 'Elaboramos exhibidores para supermercados, expos, convenciones, terminaciones para muebles del hogar, portones basculantes, tinglados (chapas, ACM, acero inox, policarbonato).',
        imagenes: [

        ]
    },
    {
        id: 2,
        icon: 'fas fa-hammer',
        nombre: 'Carpintería',
        descripcion: 'Desarrollamos Stands, muebles para eventos, obsequios en mdf, pino, terciada melanina todo para Btl.',
        descripcionLarga: 'Desarrollamos Stands, muebles para eventos, obsequios en mdf, pino, terciada melanina todo para Btl.',
        imagenes: [
            '/assets/image/galeria/carpinteria/1.jpeg',
            'assets/image/galeria/carpinteria/3.jpg',
            'assets/image/galeria/carpinteria/4.jpeg',
            'assets/image/galeria/carpinteria/2.jpeg',
        ]
    },
    {
        id: 3,
        icon: 'fas fa-print',
        nombre: 'Impresiones',
        descripcion: 'En lona, adhesivos, corte de plotter, 1440 y 720 dpi.',
        descripcionLarga: 'En lona, adhesivos, corte de plotter, 1440 y 720 dpi.',
        imagenes: [
            'assets/image/galeria/impresiones/1.jpg',
            'assets/image/galeria/impresiones/2.jpg',
            'assets/image/galeria/impresiones/3.jpg',
            'assets/image/galeria/impresiones/4.jpg',
            'assets/image/galeria/impresiones/5.jpg',
            'assets/image/galeria/impresiones/6.jpg',
            'assets/image/galeria/impresiones/7.jpg',
            'assets/image/galeria/impresiones/8.jpg',
            'assets/image/galeria/impresiones/9.jpg',
            'assets/image/galeria/impresiones/10.jpg'
        ]
    },
    {
        id: 4,
        icon: 'fas fa-truck',
        nombre: 'Logística y montajes',
        descripcion: 'Nos encargamos de todo lo esencial que el cliente necesite transportar con los mayores cuidados para la tranquilidad y facilidad del cliente.',
        descripcionLarga: 'Nos encargamos de todo lo esencial que el cliente necesite transportar con los mayores cuidados para la tranquilidad y facilidad del cliente.',
        imagenes: [
            'assets/image/galeria/montaje/1.jpg',
            'assets/image/galeria/montaje/2.jpg',
            'assets/image/galeria/montaje/3.jpg',
            'assets/image/galeria/montaje/4.jpeg',
        ]
    },
    {
        id: 5,
        icon: 'fas fa-gifts',
        nombre: 'Merchandising',
        descripcion: 'Producción de llaveros, bolígrafos, kepis, tazas con diseños para empresas.',
        descripcionLarga: 'Producción de llaveros, bolígrafos, kepis, tazas con diseños para empresas.',
        imagenes: [
            '',
            '',
            '',
        ]
    },
    {
        id: 6,
        icon: 'fas fa-user-tag',
        nombre: 'Uniformes empresariales',
        descripcion: 'Confección de uniformes empresariales, para promotoras de eventos y supermercados serigrafiado, bordados y sublimados.',
        descripcionLarga: 'Confección de uniformes empresariales, para promotoras de eventos y supermercados serigrafiado, bordados y sublimados.',
        imagenes: [
            '',
            '',
            '',
        ]
    },
    {
        id: 7,
        icon: 'fas fa-pencil-alt',
        nombre: 'Letras corpóreas',
        descripcion: 'Permiten destacar la presencia de la marca, servicio o entidad que tienen función como cartelería o decoración, pueden ser para exteriores o interiores. En cuanto a los materiales pueden ser chapa, acero (exterior) o polyfan, mdf, acrílico, etc.',
        descripcionLarga: 'Permiten destacar la presencia de la marca, servicio o entidad que tienen función como cartelería o decoración, pueden ser para exteriores o interiores. En cuanto a los materiales pueden ser chapa, acero (exterior) o polyfan, mdf, acrílico, etc.',
        imagenes: [
            'assets/image/galeria/letrascorporeas/1.jpg',
            'assets/image/galeria/letrascorporeas/2.jpg',
            'assets/image/galeria/letrascorporeas/3.jpeg',
        ]
    },
    {
        id: 8,
        icon: 'fas fa-layer-group',
        nombre: 'Acrílicos',
        descripcion: 'Realizamos todo tipo de trabajos en acrílico Desde mamparas separadoras para oficinas, porta panfletos, porta celulares todo lo que el cliente necesite.',
        descripcionLarga: 'Realizamos todo tipo de trabajos en acrílico Desde mamparas separadoras para oficinas, porta panfletos, porta celulares todo lo que el cliente necesite.',
        imagenes: [
            '',
            '',
            '',
        ]
    },
    {
        id: 9,
        icon: 'fas fa-home',
        nombre: 'Servicios para el hogar',
        descripcion: 'Porta hornos, terminaciones en acero inoxidable, colocación de purificadores, campanas extractoras, limpiezas de los mismos y limpieza de quinchos y chimeneas.',
        descripcionLarga: 'Porta hornos, terminaciones en acero inoxidable, colocación de purificadores, campanas extractoras, limpiezas de los mismos y limpieza de quinchos y chimeneas.',
        imagenes: [
            '',
            '',
            '',
        ]
    },
    {
        id: 10,
        icon: 'fas fa-globe',
        nombre: 'Sitios web institucionales',
        descripcion: 'Diseño moderno y desarrollo de sitios web institucionales, con tecnología de punta y tendencias actuales.',
        descripcionLarga: 'Su marca necesita ser conocida en la web y que aparezca como opción cuando el usuario lo busque en internet. Por eso, hacemos uso de todas las herramientas disponibles de manera que pueda llegar a todos los usuarios sea cual fuere el dispositivo que utilice. Nos encargamos de crear la mejor experiencia para los usuarios en todas las plataformas, smartphones y tablets.',
        imagenes: [
            'assets/image/galeria/web/aguaceleste.png',
            'assets/image/galeria/web/drclick.png',
            'assets/image/galeria/web/medicis.png',
            'assets/image/galeria/web/ideasweb.png',
            'assets/image/galeria/web/ogami.png',
            'assets/image/galeria/web/oruga.png',
        ]
    }


];
